"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledXOfY = exports.StyledCaretRight = exports.StyledCaretLeft = exports.StyledFlexItem = exports.StyledFlexWrapper = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var themes_1 = require("../../../../../../themes");
var mixins_1 = require("../../../../../../themes/mixins");
exports.StyledFlexWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  overflow: hidden;\n  position: relative;\n"], ["\n  display: flex;\n  overflow: hidden;\n  position: relative;\n"])));
exports.StyledFlexItem = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex-shrink: 0;\n  width: 100%;\n  position: relative;\n  margin-left: ", ";\n  ", ";\n"], ["\n  flex-shrink: 0;\n  width: 100%;\n  position: relative;\n  margin-left: ", ";\n  ", ";\n"])), function (_a) {
    var marginLeft = _a.marginLeft;
    return marginLeft;
}, (0, mixins_1.transition)("margin-left"));
var caretCommonCss = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  cursor: pointer;\n  z-index: 100;\n  top: ", ";\n"], ["\n  position: absolute;\n  cursor: pointer;\n  z-index: 100;\n  top: ", ";\n"])), function (_a) {
    var imageMinusCaptionHeight = _a.imageMinusCaptionHeight;
    return imageMinusCaptionHeight && (imageMinusCaptionHeight / 2) + 'px';
});
exports.StyledCaretLeft = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  transform: translateY(-50%);\n  left: 0;\n  \n"], ["\n  ", ";\n  transform: translateY(-50%);\n  left: 0;\n  \n"])), caretCommonCss);
exports.StyledCaretRight = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  transform: translateY(-50%);\n  right: 0;\n"], ["\n  ", ";\n  transform: translateY(-50%);\n  right: 0;\n"])), caretCommonCss);
exports.StyledXOfY = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: absolute;\n  top: ", ";\n  border: 1px solid ", ";\n  background-color: ", ";\n  width: 4rem;\n  left: 50%;\n  transform: translate(-50%, -100%);        \n  text-align: center;\n"], ["\n  position: absolute;\n  top: ", ";\n  border: 1px solid ", ";\n  background-color: ", ";\n  width: 4rem;\n  left: 50%;\n  transform: translate(-50%, -100%);        \n  text-align: center;\n"])), function (_a) {
    var imageMinusCaptionHeight = _a.imageMinusCaptionHeight;
    return imageMinusCaptionHeight && (imageMinusCaptionHeight - 10) + 'px';
}, themes_1.colors.greyColor10, themes_1.colors.white_opacity80);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
